// Lib
import * as Immutable from 'immutable';

// Constants
import { THEMES } from '../../theme/themeConstants';
import { ELECTRON_THEME_CHANGE } from './electronThemeConstants';

const initialState = Immutable.Map({
    nativeTheme: THEMES.LIGHT,
});

/**
 * Stores the Electron native theme so the web theme can follow the desktop OS preference.
 */
export default (state = initialState, action) => {
    switch (action.type) {
        case ELECTRON_THEME_CHANGE:
            return state.set('nativeTheme', action.theme);
        default:
            return state;
    }
};
